import translations from "../../translations/resources/en-GB.json";
export var annotationControlLabel = '<div style="padding-top:10px; padding-left:10px;"><svg width="20" height="20" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    // eslint-disable-next-line max-len
    '<path d="M11.175 28.3375L11.196 28.3218L11.2152 28.3039L18.9463 21.125H24.375C25.5022 21.125 26.5832 20.6772 27.3802 19.8802C28.1772 19.0832 28.625 18.0022 28.625 16.875V7.5C28.625 6.37283 28.1772 5.29183 27.3802 4.4948C26.5832 3.69777 25.5022 3.25 24.375 3.25H5.625C4.49783 3.25 3.41683 3.69777 2.6198 4.4948C1.82277 5.29183 1.375 6.37283 1.375 7.5V16.875C1.375 18.0022 1.82277 19.0832 2.6198 19.8802C3.41683 20.6772 4.49783 21.125 5.625 21.125H8.875V27.1875C8.875 27.4545 8.94934 27.7161 9.08969 27.9432C9.23004 28.1703 9.43086 28.3539 9.66963 28.4732C9.90841 28.5926 10.1757 28.6432 10.4416 28.6192C10.7075 28.5952 10.9614 28.4977 11.175 28.3375Z" fill="#101723" fill-opacity="0.95" stroke="white"/>' +
    "</svg></div>";
export var REQUEST_UPDATE_BUTTON = translations.data["venonboard.menuBar.requestUpdate"];
export var INFOBUBBLE_HEADER = {
    TITLE: translations.data["venonboard.jsMap.updateRequest"],
};
export var INFOBUBBLE_STATE;
(function (INFOBUBBLE_STATE) {
    INFOBUBBLE_STATE["OPEN"] = "open";
    INFOBUBBLE_STATE["CLOSED"] = "closed";
})(INFOBUBBLE_STATE || (INFOBUBBLE_STATE = {}));
export var ANNOTATION_DISCARD_MODAL = {
    MESSAGE: translations.data["venonboard.annotationDisacrdModal.message"],
};
export var ANNOTATION_ENTRY_MODAL = {
    UPLOAD_FLOOR_PLANS: translations.data["venonboard.annotationEntryScreen.uploadFloorPlansTxt"],
    COMMENT_ON_MAP: translations.data["venonboard.annotationEntryScreen.commentTxt"],
    HEADER: translations.data["venonboard.annotationEntryScreen.header"],
};
export var ANNOTATION_REQUEST_UPDATE_MODAL = {
    HEADER: translations.data["venonboard.requestUpdateModal.Header"],
    MESSAGE_TITLE_1: translations.data["venonboard.requestUpdateModal.messageTitle1"],
    MESSAGE_TITLE_2: translations.data["venonboard.requestUpdateModal.messageTitle2"],
    MESSAGE: translations.data["venonboard.requestUpdateModal.message"],
};
export var ANNOTATION_SUBMITREQUEST_DISCARD_MODAL = {
    HEADER: translations.data["venonboard.discardSubmitRequest.Header"],
    MESSAGE: translations.data["venonboard.discardSubmitRequest.message"],
};
export var ANNOTATION_MODAL_BUTTON = {
    DISCARD: translations.data["venonboard.annotationDiscardModal.discardButton"],
    KEEP: translations.data["venonboard.annotationDiscardModal.keepButton"],
    SUBMIT: translations.data["venonboard.button.submit"],
    CANCEL: translations.data["venonboard.form.cancel"],
    DISCARD_CHANGES: translations.data["venonboard.discardSubmitRequest.discardBtn"],
};
